module.exports = __webpack_public_path__ + "static/img/welcome.1108360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-onboarding/welcome.png
// module id = T8VN
// module chunks = 45